import { PropTypes, Component } from 'react';
import { connect } from 'react-redux';

import { trackImpression } from 'store/experiments/experiments';

const mapStateToProps = ({ experiments }) => ({
  experiments: experiments.experiments
});

const mapDispatchToProps = dispatch => ({
  variantImpression: (experimentId, experimentInfo) => dispatch(trackImpression(experimentId, experimentInfo))
});

@connect(mapStateToProps, mapDispatchToProps)
export default class Variant extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    experiments: PropTypes.object.isRequired,
    experiment: PropTypes.string.isRequired,
    variation: PropTypes.number.isRequired,
    variantImpression: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const { experiments, experiment, variation } = props;
    const experimentInfo = experiments[experiment];

    if (experimentInfo) {
      this.isExperimentActive = true;
      this.shouldVariantDisplay = (variation === experimentInfo.variation.index);
    } else {
      this.isExperimentActive = false;
      this.shouldVariantDisplay = (variation === 0);
    }
  }

  componentDidMount() {
    if (this.shouldVariantDisplay && this.isExperimentActive) {
      const { experiments, experiment } = this.props;
      const experimentInfo = experiments[experiment];

      this.props.variantImpression(experiment, experimentInfo);
    }
  }

  render() {
    const { children } = this.props;

    return (
      this.shouldVariantDisplay ? children : null
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Variant/Variant.js
 **/